import { render, staticRenderFns } from "./SkuBindingView.vue?vue&type=template&id=4e4c2112&scoped=true&"
import script from "./SkuBindingView.vue?vue&type=script&lang=js&"
export * from "./SkuBindingView.vue?vue&type=script&lang=js&"
import style0 from "./SkuBindingView.vue?vue&type=style&index=0&id=4e4c2112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c2112",
  null
  
)

export default component.exports